import * as React from 'react';
import styled from 'styled-components';
import { rem, darken } from 'polished';
import { Button } from '../General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRow,
  FlexColCenter,
  FlexCol,
} from '../../Defaults/Flexbox/Flexbox';
import * as cartSrc from '../../../../assets/zemplin/cart.svg';
import { __ } from 'react-i18n';

interface Props {
  onButtonClick: any;
  onRequestClick: any;
  disabled?: boolean;
}

function BigButtonWithRequest({
  onButtonClick,
  onRequestClick,
  disabled,
}: Props) {
  const handleRequestClick = e => {
    onRequestClick();
  };

  return (
    <Wrapper>
      <CartButton
        // disabled={disabled}
        type="button"
        onClick={onButtonClick}
      >
        <IconImg
          // disabled={disabled}
          cursor={'pointer'}
          src={cartSrc.toString()}
          alt="Pridať do košíka"
          marginRight={false}
        />
        <ToCartText>{__('Do košíka')}</ToCartText>
      </CartButton>
      <DropdownWrapper type="button" onClick={handleRequestClick}>
        {'Dopytovať'}
      </DropdownWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  position: relative;
  justify-content: flex-end;
  width: 100%;
  max-width: ${rem(400)};

  ${({ theme }) => theme.mediab.l925`
    max-width: ${rem(448)};
  `}
`;

const CartButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.secondary};
  border-radius: ${rem(2)} 0px 0px ${rem(2)};
  padding: ${rem(8)} ${rem(12)};
  margin-bottom: ${rem(16)};
  color: ${({ theme }) => theme.colors.black};
  font-weight: 300;

  &:hover {
    filter: brightness(90%);
    transition: filter 0.2s ease;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.disabled};
  }

  ${({ theme }) => theme.mediab.l925`
    font-weight: 400;
  `}
`;

const DropdownWrapper = styled(Button)`
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 100%;
  height: ${rem(48)};
  color: ${({ theme }) => theme.colors.black};
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  border-radius: ${rem(2)};
  padding: ${rem(8)} ${rem(12)};
  background: white;
  border: ${({ theme }) => theme.borders.primary};
  font-weight: 300;

  &:hover {
    filter: brightness(90%);
    transition: filter 0.2s ease;
  }

  ${({ theme }) => theme.mediab.l925`
    font-weight: 400;
  `}
`;

const ToCartText = styled.span`
  margin-left: ${rem(12)};
  display: flex;
  align-items: flex-end;
`;
export { BigButtonWithRequest };
